import { render } from "./ServeCenter.vue?vue&type=template&id=8f61eab4&scoped=true"
import script from "./ServeCenter.vue?vue&type=script&lang=js"
export * from "./ServeCenter.vue?vue&type=script&lang=js"

import "./ServeCenter.vue?vue&type=style&index=0&id=8f61eab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f61eab4"]])

export default __exports__